import { IPage } from '@/modules/pages/dist/types';

export default class PagesState {
  pages: IPage[] = [];
  currentPage: Nullable<IPage> = null;
}
